<template>
  <div class="home">
    <div class="lang_toggle">
      <span :class="btnLangClass('pt')" @click="onPtPress">PT
      </span> | <span :class="btnLangClass('en')" @click="onEnPress">EN</span>
    </div>
    <!-- Responsive YouTube Player -->
    <div class="video-container">
      <div id="player"></div>
    </div>

    <p class="content__title" v-html="titleText"></p>
    <!-- Timestamp List -->
    <ul class="timestamps">
      <li v-for="(mark, index) in currentTimeMarks" :key="index">
        <button @click="seekTo(mark.seconds)">{{ mark.time }}</button>
        <span v-if="mark.label" class="timestamp-label">{{ mark.label }}</span>
      </li>
    </ul>
    <p class="content__text" v-html="footerText"></p>
    <!-- <p class="content__text">This is the Bubuia <strong>audio</strong> view.</p> -->
    <!-- <div class="video-container">
      <iframe name="videoIframe" width="560" height="315" src="https://www.youtube.com/embed/zcUAA36Qh5w"
        title="YouTube video" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>

    <a href="https://www.youtube.com/embed/zcUAA36Qh5w?start=60" target="videoIframe">Start at 1:00</a> -->
  </div>
</template>

<script>
export default {
  name: 'BubuiaAudio',
  components: {
  },
  data() {
    return {
      selectedLang: null, // 'en' or 'pt'
      player: null,
      videos: {
        en: "JGNajAla1Eo",
        pt: "zcUAA36Qh5w"
      },
      titles: {
        pt: "O \"Mergulho do Mergulhão\" é a narrativa sonora que acompanha a visita à exposição na Estufa Fria de Lisboa. ",
        en: "\"The Grebe's Dive\" is the sound narrative that follows the exhibition at Estufa Fria de Lisboa."
      },
      messages: {
        pt: `A Bubuia leva o tempo dela a percorrer.<br>
Navegue a linha do tempo e leve o seu,<br>
ao seu ritmo na correnteza do viver.`,
        en: `Bubuia takes its time to go through.<br>
Navigate the timeline and take yours too,<br>
at your pace, in the stream of living.`
      },
      timeMarks: {
        pt: [
          { time: "00:00", label: "Introdução", seconds: 0 },
          { time: "00:50", label: "Casas 1 e 2", seconds: 50 },
          { time: "01:31", label: "Casa 3", seconds: 91 },
          { time: "02:33", label: "Casa 4", seconds: 153 },
          { time: "03:42", label: "Casa 5", seconds: 222 },
          { time: "04:42", label: "Casa 6", seconds: 282 },
          { time: "06:02", label: "Casa 7", seconds: 362 },
          { time: "07:24", label: "Casa 8", seconds: 444 },
          { time: "08:15", label: "Casa 9", seconds: 495 },
          { time: "09:09", label: "Casa 10", seconds: 549 },
          { time: "09:56", label: "Casa 11", seconds: 596 },
          { time: "10:51", label: "Casa 12", seconds: 651 },
          { time: "11:48", label: "Casa 13", seconds: 708 },
          { time: "13:48", label: "Casa 14", seconds: 828 },
          { time: "14:55", label: "Casa 15", seconds: 895 },
          { time: "15:42", label: "Casa 16", seconds: 942 },
          { time: "16:21", label: "Casa 17", seconds: 981 },
          { time: "17:19", label: "Casas 18 e 19", seconds: 1039 },
          { time: "18:30", label: "Casa 20", seconds: 1110 },
          { time: "19:33", label: "Casa 21", seconds: 1173 },
          { time: "20:41", label: "Casas 22 e 23", seconds: 1241 },
          { time: "22:19", label: "Casa 24", seconds: 1339 },
          { time: "25:44", label: "Casa 25", seconds: 1544 }
        ], en: [
          { time: "00:00", label: "Intro", seconds: 0 },
          { time: "00:49", label: "Houses 1 & 2", seconds: 49 },
          { time: "01:32", label: "House 3", seconds: 92 },
          { time: "02:38", label: "House 4", seconds: 158 },
          { time: "03:42", label: "House 5", seconds: 222 },
          { time: "04:43", label: "House 6", seconds: 283 },
          { time: "06:02", label: "House 7", seconds: 362 },
          { time: "07:24", label: "House 8", seconds: 444 },
          { time: "08:15", label: "House 9", seconds: 495 },
          { time: "09:09", label: "House 10", seconds: 549 },
          { time: "09:56", label: "House 11", seconds: 596 },
          { time: "10:52", label: "House 12", seconds: 652 },
          { time: "11:49", label: "House 13", seconds: 709 },
          { time: "13:48", label: "House 14", seconds: 828 },
          { time: "14:55", label: "House 15", seconds: 895 },
          { time: "15:42", label: "House 16", seconds: 942 },
          { time: "16:21", label: "House 17", seconds: 981 },
          { time: "17:19", label: "House 18 & 19", seconds: 1039 },
          { time: "18:30", label: "House 20", seconds: 1110 },
          { time: "19:33", label: "House 21", seconds: 1173 },
          { time: "20:42", label: "House 22 & 23", seconds: 1242 },
          { time: "22:19", label: "House 24", seconds: 1339 },
          { time: "24:12", label: "House 25", seconds: 1452 }
        ]
      }
    };
  },
  created() {
    const locale = navigator.language || navigator.userLanguage;
    if (locale) {
      const lang = locale.split("-")[0]; // e.g. "en" or "pt"
      this.selectedLang = lang === 'pt' ? 'pt' : 'en';
    } else {
      this.selectedLang = 'en';
    }
  },
  mounted() {
    // Load YouTube IFrame API once
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);

      // Wait for global callback
      window.onYouTubeIframeAPIReady = this.initPlayer;
    } else if (window.YT && window.YT.Player) {
      this.initPlayer();
    }
  },
  computed: {
    currentVideo() {
      if (!this.selectedLang) return this.videos.en;
      return this.videos[this.selectedLang] || this.videos.en;
    },
    titleText() {
      if (!this.selectedLang) return this.titles.en;
      return this.titles[this.selectedLang] || this.titles.en;
    },
    footerText() {
      if (!this.selectedLang) return this.messages.en;
      return this.messages[this.selectedLang] || this.messages.en;
    },
    currentTimeMarks() {
      if (!this.selectedLang) return this.timeMarks.en;
      return this.timeMarks[this.selectedLang] || this.timeMarks.en;
    }
  },
  methods: {
    btnLangClass(lang) {
      return {
        'lang_toggle__link': true,
        'lang_toggle__link--active': this.selectedLang === lang
      };
    },
    onEnPress() {
      this.selectedLang = "en";
      this.changeVideo();
    },
    onPtPress() {
      this.selectedLang = "pt";
      this.changeVideo();
    },
    changeVideo() {
      if (this.player && this.player.loadVideoById) {
        this.player.loadVideoById(this.currentVideo);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    initPlayer() {
      this.player = new window.YT.Player("player", {
        videoId: this.currentVideo,
        playerVars: { modestbranding: 1, rel: 0 }
      });
      // this.player = new window.YT.Player("player", {
      //   videoId: "zcUAA36Qh5w", // Your video ID
      //   playerVars: { modestbranding: 1, rel: 0 }
      // });
    },
    seekTo(seconds) {
      if (this.player && this.player.seekTo) {
        this.player.seekTo(seconds, true);
        this.player.playVideo();
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .video-container {
//   position: relative;
//   width: 100%;
//   padding-bottom: 56.25%;
//   /* 16:9 aspect ratio */
//   height: 0;
//   overflow: hidden;
// }

// .video-container iframe {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   border: 0;
// }

.home {
  width: 100%;
  padding-left: $content-padding;
  padding-right: $content-padding;
  padding-bottom: $content-padding;
  max-width: 700px;
}

.content {
  &__title {
    font-family: $base-font-family;
    font-size: 1rem !important;
    line-height: 1.4 !important;
    // font-weight: 600;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 30px;
  }

  &__text {
    font-family: $base-font-family;
    font-size: 0.8rem !important;
    line-height: 1.3 !important;
    margin-top: 30px;
    text-align: left; //justify;
  }
}

.lang_toggle {
  display: flex;
  margin-bottom: 2 * $content-padding;
  color: #cccccc;
  align-items: center;
  justify-content: center;

  &__link {
    font-family: $base-font-family;
    font-size: 0.88rem !important;
    color: #cccccc;
    cursor: pointer;
    text-decoration: none;
    padding: 8px 6px;

    &:hover {
      text-decoration: underline;
      // color: $theme-color-primary;
      // color: darken($theme-color-primary, 10%);
    }

    &--active {
      // font-weight: 600;
      color: #666666;
      cursor: default;

      &:hover {
        text-decoration: none;
        // color: $theme-color-primary;
        // color: darken($theme-color-primary, 10%);
      }
    }
  }
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  /* 16:9 ratio */
  height: 0;
}

::v-deep #player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.timestamps {
  list-style: none;
  padding: 0;
  text-align: left;
}

.timestamps li {
  font-family: $base-font-family;
  font-size: 1rem !important;
  margin-bottom: 0.2rem;
}

.timestamps button {
  font-family: $base-font-family;
  background: none;
  border: none;
  color: $theme-color-primary;
  font-size: 0.9rem;
  cursor: pointer;
  text-align: left;
  padding: 0;
  padding-top: 6px;
  padding-bottom: 6px;
  min-width: 50px;
}

.timestamps button:hover {
  text-decoration: underline;
}
</style>
